<template>
  <read_layout
    :backto="`/mag/${brandCode}/${issueId}`"
    :title="issueData.mgName"
    @caleclick="switchSilder"
  >
    <loading :active.sync="loading" loader="bars" color="#00ab00"></loading>
    <div :class="full ? 'fullscreen' : 'pager'">
      <div class="sizebar">
        <vueslider v-model="size" min="20" />
      </div>
      <span class="actable" @click="pre">
        <span :class="haspre || 'hidden'" class="iconfont iconpre"></span>
      </span>

      <image-loader
        @loaded="initscale"
        id="cover"
        @dblclick="swithFull"
        class="magcontent"
        :src="cover"
        :height="coverheight"
        width="auto"
      />
      <span class="actable" @click="next">
        <span :class="hasnext || 'hidden'" class="iconfont iconnext"></span>
      </span>
    </div>
    <silder
      :show.sync="showsilder"
      :brandCode="brandCode"
      @close="switchSilder"
    ></silder>
    <bottom
      :show="pageNo > -1"
      :title="current.title"
      :magname="current.mgName"
      :issueno="current.issueNo"
      :hcontent="current.htmlContent"
    ></bottom>
  </read_layout>
</template>

<script>
import ReadLayout from "../components/_layout/read_layout";
import Silder from "../components/Silder";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import BottomSilder from "../components/BottomSilder";
import { getCacheIssue, cacheIssue } from "../libs/utils";
import { get } from "../libs/request";
import { API } from "../libs/consts";

export default {
  name: "ReadLayout",
  components: {
    read_layout: ReadLayout,
    silder: Silder,
    bottom: BottomSilder,
    vueslider: VueSlider,
  },
  data() {
    return {
      totalPage: 0,
      issueData: {},
      current: { cover: "" },
      coverInd: 0,
      cover: "",
      cache: {},
      loading: false,
      showsilder: false,
      full: false,
      scale: 0,
      size: 1,
    };
  },
  computed: {
    issueId() {
      return this.$route.params.issueId;
    },
    brandCode() {
      return this.$route.params.brandCode;
    },
    pageNo() {
      if (this.$route.params.pageNo == undefined) return -1;
      else return Number(this.$route.params.pageNo);
    },
    hasnext() {
      if (this.pageNo == -1) return true;
      const maxPage =
        this.current.pages == undefined ? 0 : this.current.pages.length;
      return this.totalPage > this.pageNo + 1 || maxPage > this.coverInd + 1;
    },
    haspre() {
      return this.pageNo > -1;
    },
    coverheight() {
      if (this.full) {
        const ele = document.querySelector("#cover>img");
        return Math.round((ele.naturalHeight * this.size) / 100) + "px";
      } else {
        return undefined;
      }
    },
  },
  async created() {
    await this.loadIssuseData();

    //mnid
    if (!isNaN(this.pageNo)) {
      await this.loadCurrentPager();
    }
  },
  methods: {
    initscale() {
      const ele = document.querySelector("#cover>img");
      this.scale = ele.height / ele.naturalHeight;
      this.size = Math.round(this.scale * 100);
    },
    swithFull() {
      this.full = !this.full;
    },
    loadIssuseData: async function () {
      let data = getCacheIssue(this.issueId);
      if (data == undefined || data === "{}") {
        this.loading = true;
        const rps = await get(API.magz.brand.issue(this.issueId), {
          issueId: this.issueId,
          brandCode: this.brandCode,
        });
        if (rps.errMsg == API.Code.ok) {
          data = rps.data;
          cacheIssue(this.issueId, rps.data);
        }
        this.loading = false;
      }
      this.issueData = data;
      this.totalPage = data.pageList == undefined ? 1 : data.pageList.length;

      //mnid
      if (isNaN(this.pageNo)) {
        const mnid = this.$route.params.pageNo;
        const ind = data.pageList.findIndex((x) => x.mnId == mnid);
        this.$router.replace(
          `/read/${this.brandCode}/${this.issueId}/${ind > -1 ? ind : -1}`
        );
      }
    },
    loadCurrentPager: async function (next = true) {
      if (this.pageNo == -1) {
        this.current = { pages: [] };
        this.cover = this.issueData.cover;
        return;
      }
      const key = this.issueData.pageList[this.pageNo].mnId;
      let pager = this.cache[key];
      if (pager == undefined) {
        this.loading = true;
        const rps = await get(API.magz.brand.chapter(key));
        if (rps.errMsg == API.Code.ok) {
          this.cache[key] = rps.data;
          pager = rps.data;
        }
        this.loading = false;
      }
      this.current = pager;
      this.coverInd = next ? 0 : pager.pages.length - 1;
      this.cover = pager.pages[this.coverInd];
    },
    pre() {
      if (!this.haspre || this.loading) return;
      if (this.coverInd == 0) {
        this.$router.push(
          `/read/${this.brandCode}/${this.issueId}/${this.pageNo - 1}`
        );
      } else {
        this.coverInd--;
        this.cover = this.current.pages[this.coverInd];
      }
    },
    next() {
      if (this.loading || !this.hasnext) return;
      if (this.current.pages.length - 1 > this.coverInd) {
        this.coverInd++;
        this.cover = this.current.pages[this.coverInd];
      } else {
        this.$router.push(
          `/read/${this.brandCode}/${this.issueId}/${this.pageNo + 1}`
        );
      }
    },
    switchSilder() {
      this.showsilder = !this.showsilder;
    },
  },
  watch: {
    pageNo(newval, oldval) {
      this.loadCurrentPager(newval > oldval);
    },
  },
};
</script>

<style scoped>
.pager {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: calc(100vh - 0.8rem);
  margin-top: 0.8rem;
  transition: all 0.3s ease-out;
}

.iconfont {
  color: #777777;
  font-size: 0.6rem;
}

.pager .actable {
  /* width: 0.33rem; */
  margin: 0 0.4rem;
}

.magcontent {
  /* min-width: 4rem;
  min-height: 6rem;*/
  max-width: 80vw;
  height: 100%;
  box-shadow: 0px 0px 5px 0px rgba(132, 132, 132, 0.5);
}

.page {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.sizebar {
  display: none;
}

.fullscreen {
  position: fixed;
  overflow: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 13;
  margin: 0;
  max-width: 100vw;
  background-color: #777777;
  transition: all 0.3s ease-in;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  text-align: center;
  display: block;
}

.fullscreen .iconfont {
  color: #fff;
  position: fixed;
  top: calc(50vh - 0.3rem);
  z-index: 20;
  background: rgba(80, 80, 80, 0.4);
  border-radius: 0.4rem;
  line-height: 2;
}

.fullscreen .iconpre {
  left: 0.4rem;
}

.fullscreen .iconnext {
  right: 0.4rem;
}

.fullscreen .magcontent {
  max-width: none;
}

.fullscreen .sizebar {
  position: fixed;
  bottom: 20px;
  /* right: calc(100vh - 50px); */
  right: 20px;
  display: inline-block;
  width: 100px;
  background: rgba(80, 80, 80, 0.4);
  border-radius: 10px;
  padding: 0 8px;
  z-index: 99;
}

.hidden {
  visibility: hidden;
}
</style>